import { Box, Card, CardContent, Chip, LinearProgress, Pagination, Tooltip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ApiMetadata, ApiResultWrapper, calculatePageCount, RetractedWork } from "./CommonInterfaces";
import RetractionPanel from "./RetractionPanel";
import dayjs, { Dayjs } from "dayjs";
import { scrollToSection } from "../ScrollUtils";
import InfoIcon from '@mui/icons-material/Info';
import { auth } from "../firebase/firebase";
import { argosApiEntryPoint } from "../GlobalConfig";

function LatestRetractions() {

    const [latestRetractedWork, setLatestRetractedWork] = useState<RetractedWork[]>([])
    const [apiMetadata, setApiMetadata] = useState<ApiMetadata>()
    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [hasPageChanged, setHasPageChanged] = useState(false)
    const [selectedTimeframe, setSelectedTimeframe] = useState(3)

    var threeDaysAgo = new Date(new Date().getTime() - (96 * 60 * 60 * 1000)).setHours(0, 0, 0, 0);
    var endOfToday = new Date().setHours(23, 59, 59, 59);
    const [startDateTime, setStartDateTime] = useState<Dayjs | null>(dayjs(threeDaysAgo))
    const [endDateTime, setEndDateTime] = useState<Dayjs | null>(dayjs(endOfToday))

    const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setHasPageChanged(true);
        setPage(value);
    };



    useEffect(() => {
        async function fetchData() {
            setIsLoading(true)
            let authToken = await auth.currentUser?.getIdToken(true)
            fetch(argosApiEntryPoint + '/retraction?startDateTime='
                + startDateTime?.toISOString().replace('Z', '')
                + '&endDateTime=' + endDateTime?.toISOString().replace('Z', '')
                + '&pageNumber=' + page
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((result: ApiResultWrapper<RetractedWork>) => {
                    setIsLoading(false)
                    setLatestRetractedWork(result.data)
                    setApiMetadata(result.metadata)
                });
            // TODO : Error handling setError(true)
        }
        fetchData()
    }, [page, startDateTime, endDateTime, hasPageChanged]);


    useEffect(() => {
        if (hasPageChanged) {
            scrollToSection("latest-retracted-work")
        }
    }, [latestRetractedWork, hasPageChanged]);


    function setThreeDaysTimeframe(): void {
        var threeDaysAgo = new Date(new Date().getTime() - (96 * 60 * 60 * 1000)).setHours(0, 0, 0, 0);
        var endOfToday = new Date().setHours(23, 59, 59, 59);
        setStartDateTime(dayjs(threeDaysAgo));
        setEndDateTime(dayjs(endOfToday))
        setSelectedTimeframe(3)
        setPage(1)
    }


    function setWeekTimeframe(): void {
        var sevenDaysAgo = new Date(new Date().getTime() - (168 * 60 * 60 * 1000)).setHours(0, 0, 0, 0);
        var endOfToday = new Date().setHours(23, 59, 59, 59);
        setStartDateTime(dayjs(sevenDaysAgo));
        setEndDateTime(dayjs(endOfToday))
        setSelectedTimeframe(7)
        setPage(1)
    }

    return <>
        <div id="latest-reported-retractions" />
        <Typography gutterBottom variant="h3" component="div" sx={{ color: '#003366', fontWeight: 'bold' }}>
            Latest reported retractions
            <Tooltip title="Latest retractions that have been found in our sources, ordered by retraction date." placement="top-start">
                <InfoIcon color="primary" fontSize="small" style={{ verticalAlign: 'top' }} />
            </Tooltip>
        </Typography>
        <Card variant="outlined"
            style={{ marginBottom: 40, marginTop: 40 }} key="latest-retracted-work-key">
            <CardContent key="latest-retracted-work-content">                
                <Box marginTop={2}>
                    <Typography variant="caption">
                        Timeframe:
                        <Chip onClick={setThreeDaysTimeframe} label="Last 3 days"
                            {
                            ...(selectedTimeframe === 3) ? { variant: "filled" } : { variant: "outlined" }
                            } color="primary" sx={{ marginRight: 2 }} />
                        <Chip onClick={setWeekTimeframe} label="Last week"
                            {
                            ...(selectedTimeframe === 7) ? { variant: "filled" } : { variant: "outlined" }
                            } color="primary" />
                    </Typography>
                </Box>
                <Box marginTop={2}>
                    <Typography variant="body1">
                        {apiMetadata?.count} records
                    </Typography>
                </Box>
                {isLoading &&
                    <LinearProgress key={"latest_retractions" + Math.random()} />}
                {!isLoading &&
                    <>
                        {latestRetractedWork.map((retraction, retractionIndex) => {
                            return <RetractionPanel
                                key={retractionIndex}
                                retraction={retraction} index={0}
                                retractionIndex={retractionIndex} />
                        })
                        }
                    </>
                }
                {!isLoading &&
                    <Pagination count={calculatePageCount(apiMetadata)} page={page} onChange={handlePageChange} style={{ marginTop: 10 }} />
                }
            </CardContent>
        </Card>
    </>
}

export default LatestRetractions